const $ = selector => document.querySelector(selector);
$('#menuButton')?.addEventListener('click', () => {
  const open = $('#menuButton').getAttribute('aria-expanded') !== 'true';
  $('#menuButton').setAttribute('aria-expanded', String(open));
  $('#menuButton').setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  $('#navigation').classList.toggle('open', open);
});
document.addEventListener('keydown', event => {
  if (event.key === 'Escape') {$('#navigation')?.classList.remove('open'); $('#menuButton')?.setAttribute('aria-expanded', 'false');}
});
for (const select of document.querySelectorAll('[data-auto-submit]')) select.addEventListener('change', () => select.form.requestSubmit());
if ($('#viewer')) {
  const incoming = new URLSearchParams(location.search).get('registration');
  if (incoming) $('#viewerReg').value = incoming.slice(0, 10);
  let mounted;
  const load = () => mounted ||= import('./viewer.js').then(module => module.mountViewer()).then(viewer => viewer.render()).catch(() => {mounted = null; $('#viewerStatus').textContent = 'Preview unavailable. Please try again.';});
  const observer = new IntersectionObserver(entries => {if (entries.some(entry => entry.isIntersecting)) {observer.disconnect(); load();}}, {rootMargin: '500px'});
  observer.observe($('#viewer'));
  $('#retryViewer').addEventListener('click', load);
  $('#viewerContinue').addEventListener('click', () => {
    const query = $('#viewerReg').value.trim();
    if (query) location.href = `/search?type=product&q=${encodeURIComponent(query.replace(/\s/g, ''))}`;
  });
}
